import { defineNuxtPlugin } from '#app/nuxt'
import { LazyArticleCard, LazyArticleRelated, LazyAuthNav, LazyBreadcrumbs, LazyEventCard, LazyFacebookTile, LazyIntegrationCard, LazyJobDetails, LazyLinkedinTile, LazyModalImage, LazyPageCard, LazyPageLayout, LazySearchArticles, LazyShareArticle, LazyStarRating, LazyTabsHorizontal, LazyWebinarRegister, LazyWhitepaperCard, LazyContentFeatureIcons, LazyFormsEarlyAccess, LazyFormsProfiling, LazyFormsProfiling26, LazyFormsRegister, LazyFormsRegister25, LazyFormsRegister26, LazyFormsSuccess, LazyFormsTalkToAnExpert, LazyPageFooter, LazyPageGate, LazyPageHeader, LazyPageMenuMobile, LazyPageMenuSearch, LazySnippetButton, LazySnippetModal, LazySnippetQuote, LazySnippetSteps, LazyAccordionItem, LazyAlert, LazyArticle, LazyArticleAccordion, LazyArticleCta, LazyArticleRow, LazyArticleSlider, LazyBannerButton, LazyBannerCard, LazyBannerImage, LazyBannerQuote, LazyBlogGrid, LazyButton, LazyButtonRow, LazyCard, LazyCardColor, LazyCardGrid, LazyCardGridImage, LazyCardImage, LazyCardImageDownload, LazyCaseStudies, LazyCodeGroup, LazyCodeTab, LazyContactMap, LazyContent, LazyContentAccordion, LazyContentBody, LazyContentColumn, LazyContentImageColumns, LazyContentTitle, LazyContentTitleFeatures, LazyCtaBanner, LazyCtaContentImage, LazyCustomerStory, LazyDownloadAsset, LazyEmbedPlayer, LazyEvent, LazyEventsGrid, LazyFaqGroup, LazyFeature, LazyFeatureAccordion, LazyFeatureCardImage, LazyFeatureCards, LazyFeatureCarousel, LazyFeatureColumns, LazyFeatureContent, LazyFeatureGroup, LazyFeatureIcon, LazyFeatureIcons, LazyFeatureOverview, LazyFeatureRow, LazyFeatureSlide, LazyFeatureSlider, LazyFeatureStepsAlternate, LazyFeatureTab, LazyFeatureTable, LazyFeatureTabs, LazyFeatureThumbnails, LazyFeatureTitleCards, LazyFeatureTitleImage, LazyFeatureTitleList, LazyFormContent, LazyFormEarlyAccess, LazyFormProfiling, LazyFormRegister, LazyFormRegister25, LazyFormRegister26, LazyFormRequest, LazyFormSelect, LazyFormSurvey, LazyFormTalkToAnExpert, LazyGallery, LazyGlobalReference, LazyGrid, LazyGuide, LazyGuidesGrid, LazyHeroArticle, LazyHeroBold, LazyHeroCentered, LazyHeroImage, LazyHeroLight, LazyHeroLottie, LazyHeroThumbnail, LazyHeroTitle, LazyHeroVideo, LazyHeroWebinar, LazyHeroWebinarLive, LazyHtmlContent, LazyIntegrationOverview, LazyJobOpenings, LazyLeaderBio, LazyLeadershipCards, LazyMasonryCard, LazyMasonryFeatures, LazyMasonryGrid, LazyMenuArticle, LazyMenuBanner, LazyMenuGroup, LazyMenuParent, LazyMenuTab, LazyMindset, LazyMindsets, LazyModalContent, LazyModalForm, LazyModalGate, LazyOnboardingDashboard, LazyPage, LazyPageBanner, LazyPageGrid, LazyPageSlider, LazyPartnersRow, LazyPodcastAvatar, LazyPodcastEpisode, LazyPodcastShow, LazyPricingPlan, LazyPricingPlanCard, LazyPricingRegion, LazyPricingTable, LazyQrCode, LazyQuoteSlide, LazyQuoteSlider, LazyReview, LazyReviewsCarousel, LazySearch, LazySectionSlider, LazySliderImage, LazySmsCharacterCounter, LazySmsTemplate, LazySocialFeed, LazyStoryCard, LazyTable, LazyTableResponsive, LazyTagGrid, LazyTeaser, LazyTestimonials, LazyTitleAccordion, LazyTitleCardScroller, LazyTitleImageAccordion, LazyTitleLogosArc, LazyToneSlide, LazyToneSlider, LazyWebinarSpeakers, LazyWhitepaper, LazyWhitepaperGrid, LazyGridCard, LazyGridColumn, LazyGridImage, LazyGridRow, LazyGridSection, LazyGridSectionGroup, LazyGridText, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ArticleCard", LazyArticleCard],
["ArticleRelated", LazyArticleRelated],
["AuthNav", LazyAuthNav],
["Breadcrumbs", LazyBreadcrumbs],
["EventCard", LazyEventCard],
["FacebookTile", LazyFacebookTile],
["IntegrationCard", LazyIntegrationCard],
["JobDetails", LazyJobDetails],
["LinkedinTile", LazyLinkedinTile],
["ModalImage", LazyModalImage],
["PageCard", LazyPageCard],
["PageLayout", LazyPageLayout],
["SearchArticles", LazySearchArticles],
["ShareArticle", LazyShareArticle],
["StarRating", LazyStarRating],
["TabsHorizontal", LazyTabsHorizontal],
["WebinarRegister", LazyWebinarRegister],
["WhitepaperCard", LazyWhitepaperCard],
["ContentFeatureIcons", LazyContentFeatureIcons],
["FormsEarlyAccess", LazyFormsEarlyAccess],
["FormsProfiling", LazyFormsProfiling],
["FormsProfiling26", LazyFormsProfiling26],
["FormsRegister", LazyFormsRegister],
["FormsRegister25", LazyFormsRegister25],
["FormsRegister26", LazyFormsRegister26],
["FormsSuccess", LazyFormsSuccess],
["FormsTalkToAnExpert", LazyFormsTalkToAnExpert],
["PageFooter", LazyPageFooter],
["PageGate", LazyPageGate],
["PageHeader", LazyPageHeader],
["PageMenuMobile", LazyPageMenuMobile],
["PageMenuSearch", LazyPageMenuSearch],
["SnippetButton", LazySnippetButton],
["SnippetModal", LazySnippetModal],
["SnippetQuote", LazySnippetQuote],
["SnippetSteps", LazySnippetSteps],
["AccordionItem", LazyAccordionItem],
["Alert", LazyAlert],
["Article", LazyArticle],
["ArticleAccordion", LazyArticleAccordion],
["ArticleCta", LazyArticleCta],
["ArticleRow", LazyArticleRow],
["ArticleSlider", LazyArticleSlider],
["BannerButton", LazyBannerButton],
["BannerCard", LazyBannerCard],
["BannerImage", LazyBannerImage],
["BannerQuote", LazyBannerQuote],
["BlogGrid", LazyBlogGrid],
["Button", LazyButton],
["ButtonRow", LazyButtonRow],
["Card", LazyCard],
["CardColor", LazyCardColor],
["CardGrid", LazyCardGrid],
["CardGridImage", LazyCardGridImage],
["CardImage", LazyCardImage],
["CardImageDownload", LazyCardImageDownload],
["CaseStudies", LazyCaseStudies],
["CodeGroup", LazyCodeGroup],
["CodeTab", LazyCodeTab],
["ContactMap", LazyContactMap],
["Content", LazyContent],
["ContentAccordion", LazyContentAccordion],
["ContentBody", LazyContentBody],
["ContentColumn", LazyContentColumn],
["ContentImageColumns", LazyContentImageColumns],
["ContentTitle", LazyContentTitle],
["ContentTitleFeatures", LazyContentTitleFeatures],
["CtaBanner", LazyCtaBanner],
["CtaContentImage", LazyCtaContentImage],
["CustomerStory", LazyCustomerStory],
["DownloadAsset", LazyDownloadAsset],
["EmbedPlayer", LazyEmbedPlayer],
["Event", LazyEvent],
["EventsGrid", LazyEventsGrid],
["FaqGroup", LazyFaqGroup],
["Feature", LazyFeature],
["FeatureAccordion", LazyFeatureAccordion],
["FeatureCardImage", LazyFeatureCardImage],
["FeatureCards", LazyFeatureCards],
["FeatureCarousel", LazyFeatureCarousel],
["FeatureColumns", LazyFeatureColumns],
["FeatureContent", LazyFeatureContent],
["FeatureGroup", LazyFeatureGroup],
["FeatureIcon", LazyFeatureIcon],
["FeatureIcons", LazyFeatureIcons],
["FeatureOverview", LazyFeatureOverview],
["FeatureRow", LazyFeatureRow],
["FeatureSlide", LazyFeatureSlide],
["FeatureSlider", LazyFeatureSlider],
["FeatureStepsAlternate", LazyFeatureStepsAlternate],
["FeatureTab", LazyFeatureTab],
["FeatureTable", LazyFeatureTable],
["FeatureTabs", LazyFeatureTabs],
["FeatureThumbnails", LazyFeatureThumbnails],
["FeatureTitleCards", LazyFeatureTitleCards],
["FeatureTitleImage", LazyFeatureTitleImage],
["FeatureTitleList", LazyFeatureTitleList],
["FormContent", LazyFormContent],
["FormEarlyAccess", LazyFormEarlyAccess],
["FormProfiling", LazyFormProfiling],
["FormRegister", LazyFormRegister],
["FormRegister25", LazyFormRegister25],
["FormRegister26", LazyFormRegister26],
["FormRequest", LazyFormRequest],
["FormSelect", LazyFormSelect],
["FormSurvey", LazyFormSurvey],
["FormTalkToAnExpert", LazyFormTalkToAnExpert],
["Gallery", LazyGallery],
["GlobalReference", LazyGlobalReference],
["Grid", LazyGrid],
["Guide", LazyGuide],
["GuidesGrid", LazyGuidesGrid],
["HeroArticle", LazyHeroArticle],
["HeroBold", LazyHeroBold],
["HeroCentered", LazyHeroCentered],
["HeroImage", LazyHeroImage],
["HeroLight", LazyHeroLight],
["HeroLottie", LazyHeroLottie],
["HeroThumbnail", LazyHeroThumbnail],
["HeroTitle", LazyHeroTitle],
["HeroVideo", LazyHeroVideo],
["HeroWebinar", LazyHeroWebinar],
["HeroWebinarLive", LazyHeroWebinarLive],
["HtmlContent", LazyHtmlContent],
["IntegrationOverview", LazyIntegrationOverview],
["JobOpenings", LazyJobOpenings],
["LeaderBio", LazyLeaderBio],
["LeadershipCards", LazyLeadershipCards],
["MasonryCard", LazyMasonryCard],
["MasonryFeatures", LazyMasonryFeatures],
["MasonryGrid", LazyMasonryGrid],
["MenuArticle", LazyMenuArticle],
["MenuBanner", LazyMenuBanner],
["MenuGroup", LazyMenuGroup],
["MenuParent", LazyMenuParent],
["MenuTab", LazyMenuTab],
["Mindset", LazyMindset],
["Mindsets", LazyMindsets],
["ModalContent", LazyModalContent],
["ModalForm", LazyModalForm],
["ModalGate", LazyModalGate],
["OnboardingDashboard", LazyOnboardingDashboard],
["Page", LazyPage],
["PageBanner", LazyPageBanner],
["PageGrid", LazyPageGrid],
["PageSlider", LazyPageSlider],
["PartnersRow", LazyPartnersRow],
["PodcastAvatar", LazyPodcastAvatar],
["PodcastEpisode", LazyPodcastEpisode],
["PodcastShow", LazyPodcastShow],
["PricingPlan", LazyPricingPlan],
["PricingPlanCard", LazyPricingPlanCard],
["PricingRegion", LazyPricingRegion],
["PricingTable", LazyPricingTable],
["QrCode", LazyQrCode],
["QuoteSlide", LazyQuoteSlide],
["QuoteSlider", LazyQuoteSlider],
["Review", LazyReview],
["ReviewsCarousel", LazyReviewsCarousel],
["Search", LazySearch],
["SectionSlider", LazySectionSlider],
["SliderImage", LazySliderImage],
["SmsCharacterCounter", LazySmsCharacterCounter],
["SmsTemplate", LazySmsTemplate],
["SocialFeed", LazySocialFeed],
["StoryCard", LazyStoryCard],
["Table", LazyTable],
["TableResponsive", LazyTableResponsive],
["TagGrid", LazyTagGrid],
["Teaser", LazyTeaser],
["Testimonials", LazyTestimonials],
["TitleAccordion", LazyTitleAccordion],
["TitleCardScroller", LazyTitleCardScroller],
["TitleImageAccordion", LazyTitleImageAccordion],
["TitleLogosArc", LazyTitleLogosArc],
["ToneSlide", LazyToneSlide],
["ToneSlider", LazyToneSlider],
["WebinarSpeakers", LazyWebinarSpeakers],
["Whitepaper", LazyWhitepaper],
["WhitepaperGrid", LazyWhitepaperGrid],
["GridCard", LazyGridCard],
["GridColumn", LazyGridColumn],
["GridImage", LazyGridImage],
["GridRow", LazyGridRow],
["GridSection", LazyGridSection],
["GridSectionGroup", LazyGridSectionGroup],
["GridText", LazyGridText],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
